import Header from "../components/Authentication/Header";
import ForgotPassword from "../components/Authentication/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
    <>
      <Header title="Forgot your password?" />
      <ForgotPassword />
    </>
  );
};

export default ForgotPasswordPage;
